import { SET_CITY_List,SET_CITY_Info }from './mutationTypes.js'
export default{ 
	[SET_CITY_List](state,cityList){
		state.cityList=cityList
	},
	[SET_CITY_Info](state,cityInfo){
		state.cityInfo=cityInfo
	}
}


//////////////////
// WEBPACK FOOTER
// ./store/mutations.js
// module id = null
// module chunks = 